import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	headerHelp: {
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
	},
	help: {
		display: "inline-flex",
		color: theme.palette.custom.textSecondary,
	},
} satisfies Record<string, CSSObject>);
